<template>
  <page>
    <b-row>
      <b-col cols="12" sm="8" offset-sm="2" class="p-2">
        <h1 class="mb-3">User Guide</h1>

        <b-row>
          <b-col cols="12" md="8">
            <ul style="columns: 2" id="toc">
              <li><a href="#what">What</a></li>
              <li><a href="#how">How</a></li>
              <li><a href="#login">Log In</a></li>
              <li><a href="#homepage">Your Homepage</a></li>
              <li><a href="#jobs">Jobs</a></li>
              <li><a href="#content">Content</a></li>
              <li><a href="#referrals">Your Referrals</a></li>
              <li><a href="#rewards">Reward Shop</a></li>
              <li><a href="#profile">Your Profile</a></li>
              <li><a href="#signout">Sign Out</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#glossary">Glossary</a></li>
            </ul>
          </b-col>

          <b-col cols="12" md="4">
            <p style="text-align: center"><img style="max-width: 100%; margin: 0 auto" width="120" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-parrot.png" alt="Watch out for my top tips!" /></p>
          </b-col>
        </b-row>

        <h2 id="what">What is eXPD8 Rewards?</h2>

        <b-row>
          <b-col cols="12" md="6">
            <ul>
              <li>eXPD8 rewards is a new platform that enables our colleagues share jobs and content to earn ‘Pieces of 8’.</li>
              <li>These ‘Pieces of 8’ can be redeemed in the Reward Shop for vouchers.</li>
              <li>You can earn ‘Pieces of 8’ through sharing our current job vacancies in your local area on your social media platforms or via email.</li>
              <li>You’ll receive ‘Pieces of 8’ just for sharing the job, and you’ll also earn ‘Pieces of 8’ if the job you share results in someone getting through the interview stage, and if they are hired.</li>
              <li>You’ll alo be invited to join campaigns which will be focused on promoting a selection of jobs and will run for a specific timeframe. During campaigns, you can earn points by sharing and win ‘Pieces of 8’ for reaching the top of the leaderboard or winning the raffle!</li>
              <li>We are empowering our colleagues by putting the opportunity to earn extra in your hands!</li>
            </ul>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="400" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-rewards.png" alt="Rewards" /></p>
          </b-col>
        </b-row>

        <h2 id="how">How can I access eXPD8 Rewards?</h2>

        <b-row>
          <b-col cols="12" md="6">
            <p>You can access eXPD8 rewards via a web link or from the App.</p>
            <p>You will be sent an email from rewards@expd8.co.uk with a link to create your account – or you can <a href="https://expd8rewards.reallinks.io">click on this link</a>.</p>
            <p>If you have a company tablet, the app will already be downloaded.</p>
            <p>If you would like to <a href="https://expd8rewards.reallinks.io/app">download the app onto your personal devices</a>, click on drop down menu under your profile, and select Download App.</p>
            <p>You need to use the code: <span style="font-size: 1.4em; font-weight: bold;">XPD</span></p>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="400" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-appdownload.png" alt="Download the app" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="login">Log In</h2>

        <p>Use your email that is associated with eXPD8…</p>

        <p style="text-align: center;"><img style="max-width: 100%;" width="400" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-login.png" alt="Log in to eXPD8 Rewards" /></p>

        <p>…and use a password that is hard to guess but easy for you to remember.</p>

        <p style="font-weight: bold;">You can only register once!</p>

        <h3>Terms and Conditions</h3>

        <b-row>
          <b-col cols="12" md="6">
            <ul>
              <li>Before you use the platform, you need to view the <a href="https://expd8rewards.reallinks.io/expd8/tcs">Terms and Conditions</a>.</li>
              <li>Please make sure you have read and understood the T&amp;Cs before you use the platform.</li>
            </ul>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="400" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-tcs.png" alt="Terms and Conditions" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="homepage">Your Homepage</h2>

        <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-homepage.png" alt="Your Homepage" /></p>

        <h3>Campaigns</h3>

        <b-row>
          <b-col cols="12" md="6">
            <ul>
              <li>Here you will see the latest campaigns that you have been invited to. You may be included in several campaigns at once (scroll down to see all of your campaigns)</li>
              <li>In campaigns you earn <b>points</b> by sharing jobs, and win ‘Pieces of 8’ for reaching the top of the leaderboard or winning the raffle!</li>
              <li>The <b>leaderboard</b> will show you where you stand in comparison to other people.</li>
              <li><b>The jobs and content that are part of the campaign</b> are listed below. These are items that you can share and earn points and ‘Pieces of 8’ with. Click the green button to share.</li>
              <li>The <b>live feed</b> shows you everyone's activity in the campaign. o To look at all the jobs in a campaign, click ‘View all jobs’ and filter by the campaign name.</li>
            </ul>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-campaigns.png" alt="Campaigns" /></p>
          </b-col>
        </b-row>

        <h3>Sharing a Job or Content</h3>

        <p>Watch the video below to find out how to share a job or piece of content.

        <b-row class="mt-3 mb-3">
          <b-col cols="12" md="8">
            <div style="text-align: center;">
            <iframe style="max-width: 100%;" width="560" height="315" src="https://www.youtube-nocookie.com/embed/BR3Fo59qWDo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
          </b-col>

          <b-col cols="12" md="4">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-howtoshare.png" alt="How to Share" /></p>
          </b-col>
        </b-row>

        <p>You can share a job via email, LinkedIn, WhatsApp, Facebook, Messenger and Twitter.</p>

        <ul>
          <li>Once you have shared a job, if someone applies using your referral, you will be sent an email that looks like the one on the right.</li>
          <li>If you would like, you can choose to <b>‘recommend’</b> or <b>‘introduce’</b> this person.</li>
          <li><b>‘Recommend’</b> means you know this person well and think that they would be good for the job, and <b>‘introduce’</b> means that you simply want to make an introduction; perhaps you don’t know the person too well.</li>
          <li>You can also choose to ‘recommend’ or ‘introduce’ in the Your Referrals section of the site.</li>
        </ul>

        <h3>Leaderboard Points and ‘Pieces of 8’</h3>

        <b-row>
          <b-col cols="12" md="6">
            <p>The difference between Leaderboard Points and ‘Pieces of 8’ can be quite confusing so read on to find out what they mean…</p>

            <p><b>Leaderboard Points</b> are the points that you earn in a campaign in <b>addition</b> to ‘Pieces of 8’ that give you a place on the leaderboard.</p>

            <p>You can find out how many <b>Leaderboard Points</b> each share, interview and hire is worth by clicking on the leaderboard.</p>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-leaderboard.png" alt="Leaderboard" /></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-points.png" alt="Pieces of 8" /></p>
          </b-col>

          <b-col cols="12" md="6">
            <p><b>‘Pieces of 8’</b> are what you earn that can be exchanged for vouchers in the <a href="#rewards">Reward Shop</a>. You can find your balance in the same place.</p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="jobs">Jobs</h2>

        <p style="text-align: center"><img style="max-width: 100%;" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-nav-jobs.png" alt="Navigate to Jobs" /></p>

        <b-row>
          <b-col cols="12" md="6">
            <ul>
              <li>The ‘Jobs’ page is where you can look at all the currently job openings we have at that moment in time.</li>
              <li>You can use the filter to find particular or relevant jobs.</li>
              <li>Search for jobs by <b>Region</b>, <b>District</b>, <b>City</b>, <b>Job title</b>, <b>Activity</b> or <b>Campaign</b>.</li>
            </ul>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-jobsearch.png" alt="Jobs" /></p>
          </b-col>
        </b-row>

        <ul>
          <li>You can <b>share</b> whichever jobs to your network you would like.</li>
        </ul>

        <p style="text-align: center;"><a href="https://expd8rewards.reallinks.io/rewards-browser"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-rewardlimit.png" alt="Reward Shop limits" /></a></p>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="content">Content</h2>

        <p style="text-align: center"><img style="max-width: 100%;" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-nav-content.png" alt="Navigate to Content" /></p>

        <b-row>
          <b-col cols="12" md="6">
            <ul>
              <li>It is less likely that you will be sharing content rather than jobs to begin with, but if there is content to share, this is where to find it. You can share content in return for ‘Pieces of 8’.</li>
              <li>Content is classified as any other media not directly relating to jobs.</li>
              <li>It may be a blog post, a website link or something else.</li>
            </ul>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="400" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-content.png" alt="Content" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="referrals">Your Referrals</h2>

        <p style="text-align: center"><img style="max-width: 100%;" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-nav-referrals.png" alt="Navigate to Your Referrals" /></p>

        <b-row>
          <b-col cols="12" md="6">
            <ul>
              <li>This is the page where you can see if anyone in your network has been taken through the candidate journey, due to any posts you have shared.</li>
              <li>They will show up in the relevant boxes below.</li>
            </ul>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-referrals.png" alt="Your Referrals" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="rewards">Reward Shop</h2>

        <p style="text-align: center"><img style="max-width: 100%;" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-nav-rewards.png" alt="Navigate to the Reward Shop" /></p>

        <p>The exciting bit! This is where all your hard work gets rewarded.</p>

        <p>You can choose to exchange your 'Pieces of 8' for a range of exciting vouchers.</p>

        <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-rewardshop.png" alt="Reward Shop" /></p>

        <ul>
          <li>Check you have enough ‘Pieces of 8’ in your balance.</li>
          <li>Browse the vouchers available, or search for the one you want.</li>
          <li>Click ‘claim voucher’.</li>
          <li>You will need to wait for this voucher to be approved before it shows up in your inbox.</li>
        </ul>

        <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-rewardclaim.png" alt="Reward Claim" /></p>

        <div style="text-align: center;" class="mt-3 mb-3">
        <iframe width="560" height="315" style="max-width: 100%" src="https://www.youtube-nocookie.com/embed/AHCmQhwCh_o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>

        <b-row>
          <b-col cols="12" md="6">
            <p>When your request is approved, your voucher will appear in your email box from <b>rewards@expd8.co.uk</b>.</p>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-voucher.png" alt="Pieces of 8" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="profile">Your Profile</h2>

        <p style="text-align: center"><img style="max-width: 100%;" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-nav-yourprofile.png" alt="Navigate to the Your Profile" /></p>

        <b-row>
          <b-col cols="12" md="6">
            <p>Here, you can change your password and personal details relating to your account.</p>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="600" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-yourprofile.png" alt="Your Profile" /></p>
          </b-col>
        </b-row>

        <p>Don’t forget to save at the bottom of the page!</p>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="signout">Sign Out</h2>

        <b-row>
          <b-col cols="12" md="6">
            <p>If you need to, you can easily sign out and in from your account.</p>

            <p>Click on your profile icon and click ‘sign out’ on the drop down.</p>
          </b-col>

          <b-col cols="12" md="6">
            <p style="text-align: center;"><img style="max-width: 100%;" width="200" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-signout.png" alt="Sign out of eXPD8 Rewards" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="contact">Contact Us</h2>

        <b-row>
          <b-col>
            <p>We hope you don’t run into any issues using eXPD8 rewards, but if you do, please get in touch with us via:</p>

            <p style="font-size: 1.4em; text-align: center;"><a href="mailto:rewards@expd8.co.uk">rewards@expd8.co.uk</a></p>

            <p>…for all questions and queries!</p>
          </b-col>

          <b-col>
            <p style="text-align: center"><img style="max-width: 100%;" width="200" src="https://real-links-assets.s3.eu-west-2.amazonaws.com/expd8rewards-VNnwV/2023-07-07/01H4QQSPZSYR7ZS6X9CWWJZTBF/expd8-map.png" alt="Treasure Map" /></p>
          </b-col>
        </b-row>

        <p><a href="#toc">Back to contents</a></p>

        <h2 id="glossary">Glossary</h2>
        <dl>
          <dt>Campaign</dt>
          <dd>You will be invited to join various campaigns to promote a selection of jobs.</dd>
          <dt>Leaderboard</dt>
          <dd>A scoreboard showing the names and current scores of the leading employees within the campaign.</dd>
          <dt>Your network</dt>
          <dd>The people on your social media and in real life that you can email to share jobs and content.</dd>
          <dt>Points</dt>
          <dd>What you earn within a campaign to give you a score on the leaderboard or within a raffle.</dd>
          <dt>Candidate Journey</dt>
          <dd>The process that candidates go through from application to hire.</dd>
          <dt>Content</dt>
          <dd>A piece of media from the company, including blog posts and videos.</dd>
          <dt>Jobs</dt>
          <dd>Any jobs that are currently being advertised with eXPD8.</dd>
        </dl>

        <p><a href="#toc">Back to contents</a></p>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';

export default {
  components: {
    Page,
  },
  metaInfo: {
    title: 'User Guide',
  }
};
</script>



// WEBPACK FOOTER //
// src/views/static/clients/eXPD8UG.vue